import React from "react";
import MembershipTypeFilter from "./MembershipTypeFilter";
import StaffFilter from "./StaffFilter";
import CustomDateRanges from "./CustomDateRanges";
import DatePicker from "./DatePicker";
import { UpdateButtons } from "./UpdateButtons";

const FilterBar = () => (
  <div id="override-edit-selection-bar" className="edit-selections-bar">
    <div className="top-filter">
      <div className="top-filter__left">
        <MembershipTypeFilter />
        <StaffFilter />
      </div>
      <div />
      <div className="top-filter__right">
        <div className="select-box-no-width date-range-select-box">
          <p>Date Range</p>
          <CustomDateRanges />
        </div>

        <div className="date-select-box multi">
          <p>Date</p>
          <DatePicker />
        </div>
      </div>
    </div>

    <UpdateButtons />
  </div>
);

export default FilterBar;
